










































































































































































































































    import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
    import iView from 'iview';
    import Ajax from '../../../../lib/ajax'
    import Util from '../../../../lib/util'
    import AbpBase from '../../../../lib/abpbase'
    import BusinessField from '../../../../components/tools/businessField.vue';
    import Appconst from '../../../../lib/appconst';
import { constants } from 'zlib';
    @Component({
        name:'projectAdd',
        components: {
            BusinessField
        }
    })
    export default class projectAdd extends AbpBase {
        @Prop() editData:Object;
        projectAddForm:any = {
            projectDuration: null,
            projectAmount: null,
            members: [{
                belongOrgUnit: null,
                memberName: null
            }],
            physicalWork: null,
            projectDesign: null,
            attachs: [],
            projectCode: null,
            projectName: null,
            endDt: null,
            beginDt: null,
            entrustmentUnit: null,
            bearerUnitId: 1,
            bearerOrgId: null,
            auditLeaderId: null,
            dutyLeaderId: null,
            techLeaderId: null,
            saforId: null,
            nature: null,
            fundsSource: null,
            contractNumber: null,
            externalContractCode: null,
            centeralAmount: null,
            cityAmount: null,
            countryAmount: null,
            enterpriseAmount: null,
            contractAmount: undefined,
            area:[]
        }
        initData:any = {
            formDynamicIndex: 1,       
            formDynamic: {
                items: [
                    {
                        value: null,
                        index: 1,
                        status: 1
                    }
                ]
            },
            dicData: {},
            dicLoading: true,
            isEdit: false,
            isEditArea: false,
            booleanArr: [{label: '是', value: 1},{label: '否', value: 0}],
            fileUrl: Appconst.fileUrl,
            disabledInput: true,
            defaultFileList:[],
            threeId: '', // 三所id
            nineId: '', // 九所id
            stId: '', // 生态修复分院id
        }
        submitData:any = {}
        dateOption = {            
            startTimeOptions: {}, //开始日期设置
            endTimeOptions: {}, //结束日期设置
        }
        tempId = ''; // 临时id
        // get bearerOrgId(){
        //     // if(this.initData.dicData.bearerOrgAll != undefined){
        //     //     console.log(this.initData.dicData.bearerOrgAll)
        //     //     let a:any =  this.initData.dicData.bearerOrgAll.filter((item:any) => {
        //     //         return this.projectAddForm.bearerOrgId == item.value;
        //     //     });
        //     //     if(a.length <= 0){
        //     //         this.projectAddForm.bearerOrgId = this.initData.dicData.bearerOrgAll[0].value;
        //     //     }
        //     // }
        //     return this.projectAddForm.bearerOrgId;
        // }
        //获取合同信息
        GetContractInfo() {
            // return;
            if(!this.projectAddForm.contractNumber){
                this.$Message.error('请填写合同编号!');
                return;
            }
            Ajax.get('/api/services/app/Contract/GetContractByCodeAsync?ContractCode='+this.projectAddForm.contractNumber).then((res:any)=>{
                if(!res.data.result){
                    this.tempId = this.projectAddForm.contractNumber;
                    (this as any).$refs.projectAddForm.resetFields();
                    this.projectAddForm.contractNumber = this.tempId;
                    this.$Message.error('合同编号错误，没有找到该合同!');
                    return;
                }else{
                    this.projectAddForm.projectName = res.data.result.contractName;
                    this.projectAddForm.contractAmount = res.data.result.contractAmount ? res.data.result.contractAmount : null;                    
                    this.projectAddForm.beginDt = res.data.result.beginDt;
                    this.projectAddForm.endDt = res.data.result.endDt;
                    this.projectAddForm.entrustmentUnit = res.data.result.ownerUnit;
                    this.projectAddForm.fundsSource = res.data.result.fundsSource;
                    this.projectAddForm.bearerOrgId = res.data.result.belongOrg.id;       
                    this.projectAddForm.bearerUnitId = res.data.result.signUnit.id;
                    this.projectAddForm.auditLeaderId = res.data.result.contractProjectLeader ? res.data.result.contractProjectLeader.id : null;
                    this.initData.disabledInput = false;
                    let tempArray:any = new Array();
                    if(res.data.result.province && res.data.result.city && res.data.result.county){
                        tempArray.push(res.data.result.province.id);
                        tempArray.push(res.data.result.city.id);
                        tempArray.push(res.data.result.county.id);
                    }
                    this.projectAddForm.area = tempArray;
                    //合同金额类型判断
                    this.projectAddForm.isUnitPriceContract = res.data.result.isUnitPriceContract;
                    if(res.data.result.isUnitPriceContract){
                        this.projectAddForm.projectAmount = undefined; 
                    }else{
                        this.projectAddForm.projectAmount = res.data.result.contractAmount;
                    }
                    if(this.projectAddForm.bearerOrgId){
                        //加载二级数据
                        this.LoadSecondOrganization(this.projectAddForm.bearerOrgId);
                    }
                }
            })
        }
        //设置开始时间
        StartTimeChange(e:any) { 
            this.projectAddForm.beginDt = e;
            this.dateOption.endTimeOptions = {
                disabledDate: (date:any) => {
                    let beginDt = this.projectAddForm.beginDt ? new Date(this.projectAddForm.beginDt).valueOf() : '';
                    return date && (date.valueOf() < beginDt);
                }
            }
        }
        //设置结束时间
        EndTimeChange(e:any) { 
            this.projectAddForm.endDt = e;
            let endDt = this.projectAddForm.endDt ? new Date(this.projectAddForm.endDt).valueOf() - 1 * 24 * 60 * 60 * 1000 : '';
            this.dateOption.startTimeOptions = {
                disabledDate(date:any) {
                    return date && date.valueOf() > endDt;
                }
            }
        }
        //加减项目成员        
        handleAdd (index:any) {
            this.initData.formDynamicIndex++;
            this.initData.formDynamic.items.push({
                value: null,
                index: this.initData.formDynamicIndex,
                status: 1
            });
            this.projectAddForm.members.push({                
                belongOrgUnit: null,
                memberName: null,
                index: this.projectAddForm.members.length+1
            });
        }
        handleRemove (index:any,item:any) {
           this.projectAddForm.members.splice(index,1);
           if(this.initData.isEdit){ // 编辑时候删除数据
                Ajax.delete('/api/services/app/ProjectManager/DeleteProjectMemberAsync?id='+item.id);
           }
        }
        //删除文件
        async DeleteFile(res:any) {
            if(!!res.response){
                await Ajax.post('/api/File/DeleteTempFile?filename='+res.response.result);
                this.projectAddForm.attachs.splice(this.projectAddForm.attachs.indexOf(res.response.result), 1);
            }else{
                await Ajax.delete('/api/services/app/ProjectManager/DeleteProjectAttachAsync?ProjectId='+this.$route.query.id+'&FileId='+res.id);
                (this as any).$parent.$parent.getData(this.submitData.id);
            }
            
        }
        //上传成功回调
        UploadSuccess(res:any) {
            this.projectAddForm.attachs.push(res.result);
        }
        //设置项目编号
        async SetProjectNum(id:any) {
            this.projectAddForm.projectCode = (await Ajax.post('/api/services/app/ProjectManager/CreateProjectCode', {bearerOrgId: this.projectAddForm.bearerOrgId})).data.result;
        }
        //格式化提交的数据
        async FormatData(){
            //this.submitData = Util.extend(true, {}, this.projectAddForm);
            this.submitData = Object.assign({}, this.projectAddForm);
            this.submitData.physicalWork = !!this.submitData.physicalWork;
            this.submitData.projectDesign = !!this.submitData.projectDesign;
            //拆分地区数据
            if(this.submitData.area){
                this.submitData.cityId = this.submitData.area[0];
                this.submitData.countyId = this.submitData.area[1];
                this.submitData.provinceId = this.submitData.area[2];
            }
            //拆分业务领域数据-新增时
            if(!this.initData.isEdit){
                this.submitData.businessArea1 = (this as any).$refs.businessArea.GetData()[0];
                this.submitData.businessArea2 = (this as any).$refs.businessArea.GetData()[1];
            }
            //成员数据处理
            if(this.submitData.members.length){
                this.submitData.members = this.submitData.members.filter((item:any)=>{
                    return item.belongOrgUnit && item.memberName
                });
            }else{
                this.submitData.members = undefined;
            }
            //空对象转为空字符串
            for(let i in this.submitData){
                if(JSON.stringify(this.submitData[i]) == '{}'){
                    this.submitData[i] = '';
                }
            }
            //是否有野外工作量数据
            this.submitData.hasFieldPhysicalWorkload = this.submitData.hasFieldPhysicalWorkload == 'true'?true:false;
        }
        //动态加载地区数据
        LoadArea(item:any, callback:any){
            item.loading = true;
            Ajax.get('/api/services/app/Region/GetProvinceOrCityRegionsById?input='+item.value).then((res:any)=>{
                item.children = res.data.result.children;
                item.loading = false;
                callback();
            })
        }
        //动态加载业务领域数据
        LoadBussinessArea(item:any, callback:any){
            item.loading = true;
            Ajax.get('/api/services/app/SysBaseData/GetBussinessAreaByParentIdAsync?id='+item.id).then((res:any)=>{
                item.children = res.data.result.items.map((item:any)=>{
                    return {
                        value: item.directoryValue,
                        label: item.directoryName
                    }
                });
                item.loading = false;
                callback();
            })
        }
        //动态加载二级部门
        async LoadSecondOrganization(id:any) {
            //清空二级
            // (this as any).$refs.secondBearerOrgId.setQuery(null);
            // return;
            if(!id){
                return;
            }
            Ajax.get('/api/services/app/Organization/GetAllChildrenOrganizationByParentIdAsync?id='+id).then((res:any)=>{
                this.$set(this.initData.dicData, 'allSecondOrganization', res.data.result);
            });
            
        }
        //提交
        async Submit(){
            if(this.projectAddForm.attachs.length <= 0){
                this.$Message.error('请上传附件！');
                return;
            }
            (this.$refs.projectAddForm as any).validate(async (valid:boolean)=>{
                if (valid) {
                    this.FormatData();
                    if(!this.submitData.businessArea1.length){
                        this.$Message.error('请选择业务领域！');
                        return;
                    }
                    await Ajax.post('/api/services/app/ProjectManager/Create', this.submitData).then((res:any) => {     
                        // this.$Message.success('提交成功!');  
                        this.$Modal.success({
                            title: '项目填报',
                            content: `<p>项目填报已成功提交！</p>
                                      <p>项目编号为：${res.data.result.projectCode}</p>
                                    `,
                            onOk: () => {
                                // 填报成功，特殊资金来源弹出倒排工期弹窗
                                if(res.data.result.allowFillReverse){
                                    (this as any).$parent.$parent.ShowModal(true, res.data.result);
                                }else{
                                    setTimeout(()=>{
                                        this.$router.push({
                                            name: 'projectDetail',
                                            query: {
                                                id: res.data.result.id
                                            }
                                        })
                                    },1500)
                                }
                            },
                        });
                    })
                }
            })
        }
        //修改提交
        async Edit(){
            (this.$refs.projectAddForm as any).validate(async (valid:boolean)=>{
                if (valid) {
                    this.FormatData();
                    // this.submitData.members.forEach( (item:any,index:any) => {
                    //     if(!item.memberName || !item.belongOrgUnit){
                    //         this.submitData.members = this.submitData.members.splice(index+1,1);
                    //     }
                    // } )
                    // return;
                    //项目所在地区
                    if(this.projectAddForm.area){
                        this.submitData.provinceId = this.projectAddForm.area[2] ? this.projectAddForm.area[2] : null;
                        this.submitData.cityId = this.projectAddForm.area[0] ? this.projectAddForm.area[0] : null;
                        this.submitData.countyId = this.projectAddForm.area[1] ? this.projectAddForm.area[1] : null;
                    }
                    await Ajax.put('/api/services/app/ProjectManager/Update', this.submitData).then((res:any) => {                        
                        this.$Message.success('提交成功!');
                        (this as any).$parent.$parent.getData(this.submitData.id);
                        (this.$parent.$parent as any).editModalClose(false);
                    })
                }else{
                    setTimeout(() => {
                        (this.$parent.$parent as any).editModalOkCallbackLoading(false);
                        this.$nextTick(() => {
                            (this.$parent.$parent as any).editModalOkCallbackLoading(true);
                        });
                    }, 1000);
                }
            })
        }
        //获取地区所有信息
        GetAllRegions(){
            Ajax.get('/api/services/app/Region/GetAllRegions').then((res:any)=>{
                this.$set(this.initData.dicData, 'area', res.data.result);
            });
        }
        //获取字典,更新数据
        async GetDic() {
            await this.$store.dispatch('project/GetAllDictionary');
            await this.$store.dispatch('project/GetArea');
            await this.$store.dispatch('project/GetbearerUnit');
            await this.$store.dispatch('project/GetbearerOrg');
            await this.$store.dispatch('project/GetAllUser');
            await this.$store.dispatch('project/GetBussinessAreaAsync');
            this.$store.state.project.allDictionary.map((item:any) => {
                this.initData.dicData[item.key] = item.items.map((items:any) => {
                    return {
                        label: items.displayName,
                        value: items.id
                    }
                });
            })
            this.initData.dicData.bearerUnitId = this.$store.state.project.bearerUnitId;
            this.initData.dicData.bearerOrgAll = this.$store.state.project.bearerOrgId;
            this.initData.dicData.bearerOrgAll.map( (item: any) => {
                if (item.label == '三所' ){
                    this.initData.threeId = item.value;
                }
                if (item.label == '九所' ){
                    this.initData.nineId = item.value;
                }
                if (item.label == '生态修复分院' ){
                    this.initData.stId = item.value;
                }
            } )
            this.initData.dicData.userList = this.$store.state.project.userList;
            //获取所有区域
            await this.$store.dispatch('project/GetArea');
            // this.initData.dicData.area = this.$store.state.project.allArea.map((item:any)=>{
            //     return {
            //         value: item.value,
            //         label: item.label,
            //         children: item.children,
            //         loading: false,
            //     }
            // });
            this.GetAllRegions();
            this.initData.dicData.bussinessArea = this.$store.state.project.bussinessArea.map((item:any)=>{
                return {
                    value: item.directoryValue,
                    id: item.id,
                    label: item.directoryName,
                    children: [],
                    loading: false,
                }
            });
            this.initData.dicLoading = false;
        }
        //更新数据
        @Watch('editData')
        editDataChange(newVal:any, oldVal:any){
            this.initData.isEdit = newVal.isEdit;
            this.initData.isEditArea = true;
            this.initData.disabledInput = false;
            let tempVal = newVal;
            tempVal.beginDt = new Date(tempVal.beginDt);
            if(tempVal.members == null){
                tempVal.members = [{
                    belongOrgUnit: '',
                    memberName: '',
                    index: 1
                }]
            }
            if(tempVal.city && tempVal.county && tempVal.province) tempVal.areaTxt = tempVal.city.name+'/'+tempVal.county.name+'/'+tempVal.province.name;
            // this.LoadSecondOrganization(newVal.bearerOrgId);
            //项目所在地区
            if(tempVal.city){
                let areaArry:any = [];
                if(tempVal.city) {
                    areaArry.push(tempVal.city.id);
                }
                if(tempVal.county) {
                    areaArry.push(tempVal.county.id);
                }
                if(tempVal.province) {
                    areaArry.push(tempVal.province.id);
                }
                this.$nextTick(() => {
                    this.$set(tempVal,'area',areaArry);
                });
            } 
            if(tempVal.attachs && tempVal.attachs.length >= 1) {
                this.initData.defaultFileList = tempVal.attachs.map( (item:any) => {
                    return {
                        name:item.attachName,
                        url:item.url,
                        id:item.fileId
                    }
                } );
            }
            tempVal.attachs = [];
            this.projectAddForm = tempVal;
            // this.projectAddForm.attachs = [];
            this.projectAddForm.secondBearerOrgId = this.projectAddForm.secondBearerOrgId == '' ? null : this.projectAddForm.secondBearerOrgId;
        }
        mounted() {
            this.GetDic();
        }
        activated(){
            this.GetDic();
        }
        //验证规则
        ruleValidate = {
            projectName: [{ required: true, message: '请填写项目名称', trigger: 'blur' }],
            contractNumber: [{ required: true, message: '请填写合同编号', trigger: 'blur' }],
            bearerUnitId: [{ required: true, type: 'number', message: '请选择项目承担单位', trigger: 'change' }],
            bearerOrgId: [{ required: true, type: 'number', message: '请选择项目承担部门', trigger: 'change' }],
            // secondBearerOrgId: [{ required: true, type: 'number', message: '请选择二级部门', trigger: 'change' }],
            entrustmentUnit: [{ required: true, message: '请选择委托单位', trigger: 'change' }],
            nature: [{ required: true, type: 'number', message: '请选择项目性质', trigger: 'change' }],
            professionalNature: [{ required: true, type: 'number', message: '请选择项目专业性质', trigger: 'change' }], 
            fundsSource: [{ required: true, type: 'number', message: '请选择资金来源', trigger: 'change' }], 
            beginDt: [{ required: true, message: '请选择项目开始时间' }],
            endDt: [{ required: true, message: '请选择项目结束时间' }],
            physicalWork: [{ required: true, type: 'number', message: '请选择是否有野外实物工作量', trigger: 'change' }],
            projectDesign: [{ required: true, type: 'number', message: '请选择是否有项目设计', trigger: 'change' }],
            projectAmount: [{ required: true, type: 'number', message: '请填写正确的项目费用', trigger: 'blur' }],
            completionWay: [{ required: true, type: 'number', message: '请选择项目完成方式', trigger: 'change' }],
            projectDuration: [{ required: true, type: 'number', min: 0, message: '请填写正确的工期', trigger: 'blur' }],
            projectLeader: [{ required: true, message: '请填写项目负责人', trigger: 'blur' }],
            area: [{ required: true, type: 'array', message: '请选择行政区划', trigger: 'change' }],
            businessArea: [{ required: true, type: 'array', message: '请选择项目业务领域', trigger: 'change' }],
            auditLeaderId: [{ required: true, type: 'number', message: '请选择项目负责人', trigger: 'change' }],
            hasFieldPhysicalWorkload:[{ required: true,message: '请选择是否有野外工作量', trigger: 'change' }],
            attachs:[{required:true,type:'array',message:'请上传自审意见及修改对照表！',trigger:'change'}],
        }
    }
